<section class="confirm_bell_alerts">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
    <p class="confirm_bell_alerts--message font-primary-dark text-center mx-5">
        Puede que se muestren
        <span class="color-secondary-dark">alertas con sonido <i class="fas fa-bell"></i></span>
    </p>
    <div class="confirm_bell_alerts--options button-container">
        <button class="bg-color-primary" mat-raised-button color="primary" (click)="closeDialog()">Continuar</button>
    </div>
</section>